const init_supplier = {
  name: {
    value: "",
    label: "Supplier Name",
    placeholder: "Enter supplier name",
  },
  company: {
    value: "",
    label: "Company",
    placeholder: "Enter company name (optional)",
  },
  email: {
    value: "",
    label: "Email",
    placeholder: "Enter email (optional)",
  },
  phone: {
    value: "",
    label: "Phone",
    placeholder: "Enter phone number (optional)",
  },
  address: {
    value: "",
    label: "Address",
    placeholder: "Enter address (optional)",
  },
  status: {
    value: "active",
    label: "Status",
    placeholder: "Select status",
  },
};

export default init_supplier;
